import React from "react";
import Dialog from "Components/DesignSystem/Dialog/Dialog";
import Button from "Components/DesignSystem/Button/Button";
import Typography from "Components/DesignSystem/Typography/Typography";

interface ConfirmationModalProps {
    title: string;
    message: string;
    showModal: boolean;
    closeModal: () => void;
    onConfirm: () => void;
    confirmationButtonText?: string;
    cancelButtonText?: string;
}

/**
 * The "Change default?" confirm, on the DS `Dialog` (2026-09-08) — was the legacy
 * `Common/Modal` stack with a red `FillButton`. The confirm is `primary`, not
 * `danger-primary`: § 167 reserves the filled destructive confirm for destructive
 * acts, and setting a default version changes state without destroying anything
 * (the red was inherited styling, not semantics). Confirm still runs
 * `onConfirm()` THEN `closeModal()` — the order the parent's default-selection
 * flow relies on.
 */
const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ title, message, showModal, closeModal, onConfirm, confirmationButtonText, cancelButtonText }) => {
    return (
        <Dialog
            isOpen={showModal}
            onClose={closeModal}
            title={title}
            size="sm"
            data-testid="cs-confirmation-modal"
            footer={
                <div className="tw-flex tw-justify-end tw-gap-3">
                    <Button
                        variant="secondary"
                        data-testid="cs-confirmation-cancel-btn"
                        onClick={() => closeModal()}
                    >
                        {cancelButtonText ?? "Cancel"}
                    </Button>
                    <Button
                        variant="primary"
                        data-testid="cs-confirmation-confirm-btn"
                        onClick={() => { onConfirm(); closeModal(); }}
                    >
                        {confirmationButtonText ?? "Confirm"}
                    </Button>
                </div>
            }
        >
            <Typography variant="body-primary" as="p" data-testid="cs-confirmation-message">
                {message}
            </Typography>
        </Dialog>
    );
}

export default ConfirmationModal
